import Phaser from 'phaser';
import type { ArchetypeId } from '@/lib/archetypes';
import { ARCHETYPE_KIT_COLORS } from '@/lib/archetype-kit-colors';
import {
  KEEPER_READY_TEXTURE,
  DIVE_TEXTURE_BY_ZONE,
  type KeeperPose,
} from '@/lib/keeper-sprites';

/**
 * In-game keeper sprite. Replaces the orange keeperRect with a tinted
 * pixel-art silhouette whose pose matches where the keeper actually goes
 * each shot. Texture switching uses `setTexture(key)` because each pose
 * is a separate loaded texture, not an atlas frame within one texture —
 * `setFrame` would silently no-op. See spec §2.2 and §8 (peer-review #1).
 */
export class KeeperSprite extends Phaser.GameObjects.Image {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, KEEPER_READY_TEXTURE);
    scene.add.existing(this);
    this.setDepth(10);
  }

  setArchetype(id: ArchetypeId): this {
    this.setTint(ARCHETYPE_KIT_COLORS[id]);
    return this;
  }

  setPose(pose: KeeperPose): this {
    const key = pose === 'ready' ? KEEPER_READY_TEXTURE : DIVE_TEXTURE_BY_ZONE[pose];
    this.setTexture(key);
    return this;
  }
}
